


import React, { Fragment, useEffect } from "react";
import { useAuditPage } from "../../data/audits/useAuditsPage";
import { IPagination } from "../../interfaces/common/IPagination";
import { IAuditListFilters } from "../../interfaces/IAudit";

type IRenderProps = { page: number[], pagination: IPagination, goToPage: (page: number) => void };

interface RenderAuditPageProps {
    filters: Partial<IAuditListFilters>;

    initialPagination: IPagination;
    onPaginationChanged: (pagination: IPagination) => void;

    render: (props: IRenderProps) => any;
};

export const RenderAuditPage: React.FC<RenderAuditPageProps> = ({
    filters,

    initialPagination,
    onPaginationChanged,

    render
}) => {

    const { data: page, pagination, goToPage } = useAuditPage(initialPagination, filters);

    useEffect(() => {
        if (JSON.stringify(pagination) !== JSON.stringify(initialPagination)) {
            onPaginationChanged(pagination)
        }
    }, [pagination]); // eslint-disable-line

    return (
        <Fragment>
            {render({ page, pagination, goToPage })}
        </Fragment>
    )
};

